/* Kartograf · motore anteprima stampa (canvas, gratis nel browser)
   - maschera del capo (flood fill dello sfondo dai bordi)
   - mappa ombre/pieghe = luminanza ad alto passaggio della foto
   - displacement leggero dei pixel del logo in base alla luminanza sfocata
   - texture tessuto sottile + fusione multiply (capi chiari) / screen (capi scuri)
*/
(function () {
  var KG = window.KG = window.KG || {};

  function boxBlur(src, w, h, r) {
    var tmp = new Float32Array(w * h), out = new Float32Array(w * h), d = 2 * r + 1, x, y, acc, o;
    for (y = 0; y < h; y++) {
      o = y * w; acc = 0;
      for (x = -r; x <= r; x++) acc += src[o + Math.min(w - 1, Math.max(0, x))];
      for (x = 0; x < w; x++) {
        tmp[o + x] = acc / d;
        acc += src[o + Math.min(w - 1, x + r + 1)] - src[o + Math.max(0, x - r)];
      }
    }
    for (x = 0; x < w; x++) {
      acc = 0;
      for (y = -r; y <= r; y++) acc += tmp[Math.min(h - 1, Math.max(0, y)) * w + x];
      for (y = 0; y < h; y++) {
        out[y * w + x] = acc / d;
        acc += tmp[Math.min(h - 1, y + r + 1) * w + x] - tmp[Math.max(0, y - r) * w + x];
      }
    }
    return out;
  }
  KG.boxBlur = boxBlur;

  // texture tessuto 64x64 (trama + rumore), deterministica
  var TEX = (function () {
    var t = new Float32Array(64 * 64), s = 12345;
    function rnd() { s = (s * 1103515245 + 12345) & 0x7fffffff; return s / 0x7fffffff; }
    for (var y = 0; y < 64; y++) for (var x = 0; x < 64; x++) {
      var trama = Math.sin(x * 2.2) * Math.sin(y * 2.2) * 0.035 + Math.sin((x + y) * 0.9) * 0.012;
      t[y * 64 + x] = 1 + trama + (rnd() - 0.5) * 0.07;
    }
    return t;
  })();

  function nuovoCanvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
  KG.nuovoCanvas = nuovoCanvas;

  /* Analizza la foto del capo: restituisce tutto ciò che serve per stampare sopra */
  KG.analizzaFoto = function (img) {
    var nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
    var sc = Math.min(1, 900 / nw, 1200 / nh);
    var W = Math.round(nw * sc), H = Math.round(nh * sc), N = W * H;
    // 1) foto grezza (per l'alfa dei PNG trasparenti)
    var raw = nuovoCanvas(W, H), rc = raw.getContext('2d', { willReadFrequently: true });
    rc.drawImage(img, 0, 0, W, H);
    var rd = rc.getImageData(0, 0, W, H).data;
    // 2) foto su bianco (base dell'anteprima)
    var base = nuovoCanvas(W, H), bc = base.getContext('2d', { willReadFrequently: true });
    bc.fillStyle = '#fff'; bc.fillRect(0, 0, W, H); bc.drawImage(img, 0, 0, W, H);
    var bd = bc.getImageData(0, 0, W, H).data;
    // colore di fondo = media degli angoli
    var trasp = rd[3] < 16 && rd[(N - 1) * 4 + 3] < 16;
    var br = 0, bg = 0, bb = 0, k = 0, pts = [[2, 2], [W - 3, 2], [2, H - 3], [W - 3, H - 3]];
    pts.forEach(function (p) { var i = (p[1] * W + p[0]) * 4; br += bd[i]; bg += bd[i + 1]; bb += bd[i + 2]; k++; });
    br /= k; bg /= k; bb /= k;
    var tol = 13;
    function isBg(p) {
      var i = p * 4;
      if (trasp) return rd[i + 3] < 24;
      var dr = bd[i] - br, dg = bd[i + 1] - bg, db = bd[i + 2] - bb;
      return dr * dr + dg * dg + db * db < tol * tol * 3;
    }
    // 3) flood fill dello sfondo partendo dai bordi
    var bgm = new Uint8Array(N), stack = new Int32Array(N), sp = 0, x, y, p;
    function push(q) { if (!bgm[q] && isBg(q)) { bgm[q] = 1; stack[sp++] = q; } }
    for (x = 0; x < W; x++) { push(x); push((H - 1) * W + x); }
    for (y = 0; y < H; y++) { push(y * W); push(y * W + W - 1); }
    while (sp > 0) {
      p = stack[--sp]; x = p % W; y = (p / W) | 0;
      if (x > 0) push(p - 1); if (x < W - 1) push(p + 1);
      if (y > 0) push(p - W); if (y < H - 1) push(p + W);
    }
    // maschera morbida del capo + bounding box
    var mf = new Float32Array(N), x0 = W, y0 = H, x1 = 0, y1 = 0, cnt = 0;
    for (p = 0; p < N; p++) {
      if (!bgm[p]) { mf[p] = 1; cnt++; x = p % W; y = (p / W) | 0; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (cnt < N * 0.04) { // maschera non affidabile: tutto il centro
      x0 = W * 0.15; y0 = H * 0.1; x1 = W * 0.85; y1 = H * 0.9;
      for (p = 0; p < N; p++) mf[p] = 1;
    }
    var mfb = boxBlur(boxBlur(mf, W, H, 1), W, H, 1);
    var mask = new Uint8ClampedArray(N);
    for (p = 0; p < N; p++) mask[p] = Math.round(Math.max(0, Math.min(1, (mfb[p] - 0.15) / 0.7)) * 255);
    // 4) luminanza e mappe
    var L = new Float32Array(N);
    for (p = 0; p < N; p++) { var j = p * 4; L[p] = (0.2126 * bd[j] + 0.7152 * bd[j + 1] + 0.0722 * bd[j + 2]) / 255; }
    var Lb = boxBlur(boxBlur(L, W, H, 7), W, H, 7);      // pieghe medie
    var Lg = boxBlur(boxBlur(L, W, H, 22), W, H, 22);    // forme grandi (per il displacement)
    // colore medio nella zona petto
    var bw = x1 - x0, bh = y1 - y0, sr = 0, sg = 0, sb = 0, sl = 0, n = 0;
    for (y = Math.round(y0 + bh * 0.28); y < y0 + bh * 0.62; y += 3) for (x = Math.round(x0 + bw * 0.36); x < x0 + bw * 0.64; x += 3) {
      p = y * W + x; if (bgm[p]) continue; var q = p * 4; sr += bd[q]; sg += bd[q + 1]; sb += bd[q + 2]; sl += L[p]; n++;
    }
    n = n || 1; var meanL = sl / n;
    var chiaro = meanL > 0.5;
    var shade = new Float32Array(N), dx = new Float32Array(N), dy = new Float32Array(N), e = 0.04;
    var forza = chiaro ? 1 : 0.8;
    for (p = 0; p < N; p++) {
      var hp = (L[p] + e) / (Lb[p] + e);                       // alto passaggio: pieghe fini
      var lp = Math.pow((Lb[p] + e) / (meanL + e), chiaro ? 0.55 : 0.35); // ombre larghe
      shade[p] = Math.max(0.45, Math.min(1.35, Math.pow(hp, forza) * lp));
    }
    var dk = 26 / (meanL + 0.12);
    for (y = 3; y < H - 3; y++) for (x = 3; x < W - 3; x++) {
      p = y * W + x;
      dx[p] = Math.max(-5, Math.min(5, (Lg[p + 3] - Lg[p - 3]) * dk));
      dy[p] = Math.max(-5, Math.min(5, (Lg[p + 3 * W] - Lg[p - 3 * W]) * dk));
    }
    return {
      W: W, H: H, base: base, mask: mask, shade: shade, dx: dx, dy: dy,
      box: { x: x0, y: y0, w: bw, h: bh }, chiaro: chiaro, lum: meanL,
      colore: [Math.round(sr / n), Math.round(sg / n), Math.round(sb / n)]
    };
  };

  /* Disegna capo + logo stampato. P = {cx, cy, w, rot} in pixel della foto */
  KG.disegna = function (ctx, A, logo, P, opz) {
    opz = opz || {};
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
    ctx.clearRect(0, 0, A.W, A.H);
    ctx.drawImage(A.base, 0, 0);
    if (!logo || !P) return null;
    var W = A.W, H = A.H;
    var lw = P.w, lh = P.w * logo.height / logo.width;
    if (!A._l1) A._l1 = nuovoCanvas(W, H);
    var l1 = A._l1.getContext('2d', { willReadFrequently: true });
    l1.setTransform(1, 0, 0, 1, 0, 0); l1.clearRect(0, 0, W, H);
    l1.imageSmoothingQuality = 'high';
    l1.translate(P.cx, P.cy); l1.rotate(P.rot || 0); l1.drawImage(logo, -lw / 2, -lh / 2, lw, lh);
    l1.setTransform(1, 0, 0, 1, 0, 0);
    var c = Math.abs(Math.cos(P.rot || 0)), s = Math.abs(Math.sin(P.rot || 0));
    var bw = lw * c + lh * s, bh = lw * s + lh * c;
    var X0 = Math.max(0, Math.floor(P.cx - bw / 2 - 8)), Y0 = Math.max(0, Math.floor(P.cy - bh / 2 - 8));
    var X1 = Math.min(W, Math.ceil(P.cx + bw / 2 + 8)), Y1 = Math.min(H, Math.ceil(P.cy + bh / 2 + 8));
    var ww = X1 - X0, hh = Y1 - Y0;
    if (ww < 2 || hh < 2) return null;
    var src = l1.getImageData(X0, Y0, ww, hh).data;
    var out = l1.createImageData(ww, hh), od = out.data;
    var piatto = !!opz.piatto, chiaro = A.chiaro;
    for (var y = 0; y < hh; y++) {
      var gy = Y0 + y;
      for (var x = 0; x < ww; x++) {
        var gx = X0 + x, gi = gy * W + gx, m = A.mask[gi];
        if (m === 0) continue;
        var sx = x, sy = y;
        if (!piatto) { sx = x - A.dx[gi]; sy = y - A.dy[gi]; }
        // campionamento bilineare
        var ix = Math.floor(sx), iy = Math.floor(sy), fx = sx - ix, fy = sy - iy;
        if (ix < 0 || iy < 0 || ix >= ww - 1 || iy >= hh - 1) continue;
        var i00 = (iy * ww + ix) * 4, i10 = i00 + 4, i01 = i00 + ww * 4, i11 = i01 + 4;
        var w00 = (1 - fx) * (1 - fy), w10 = fx * (1 - fy), w01 = (1 - fx) * fy, w11 = fx * fy;
        var a = src[i00 + 3] * w00 + src[i10 + 3] * w10 + src[i01 + 3] * w01 + src[i11 + 3] * w11;
        if (a < 2) continue;
        var r = src[i00] * w00 + src[i10] * w10 + src[i01] * w01 + src[i11] * w11;
        var g = src[i00 + 1] * w00 + src[i10 + 1] * w10 + src[i01 + 1] * w01 + src[i11 + 1] * w11;
        var b = src[i00 + 2] * w00 + src[i10 + 2] * w10 + src[i01 + 2] * w01 + src[i11 + 2] * w11;
        var t = TEX[(gy & 63) * 64 + (gx & 63)];
        var kk = piatto ? 1 : A.shade[gi] * t;
        if (!chiaro && !piatto) kk *= 0.94;     // inchiostro su scuro: un filo meno brillante
        var o = (y * ww + x) * 4;
        od[o] = r * kk; od[o + 1] = g * kk; od[o + 2] = b * kk;
        od[o + 3] = a * (m / 255) * (piatto ? 1 : (0.9 + 0.1 * Math.min(1, t)));
      }
    }
    if (!A._l2 || A._l2.width < ww || A._l2.height < hh) A._l2 = nuovoCanvas(Math.max(ww, 64), Math.max(hh, 64));
    var l2 = A._l2.getContext('2d');
    l2.clearRect(0, 0, A._l2.width, A._l2.height);
    l2.putImageData(out, 0, 0);
    ctx.drawImage(A._l2, 0, 0, ww, hh, X0, Y0, ww, hh);
    if (!piatto) {
      ctx.globalCompositeOperation = chiaro ? 'multiply' : 'screen';
      ctx.globalAlpha = chiaro ? 0.3 : 0.1;
      ctx.drawImage(A._l2, 0, 0, ww, hh, X0, Y0, ww, hh);
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
    }
    return { x: X0, y: Y0, w: ww, h: hh };
  };

  /* Posizioni di stampa, relative al riquadro del capo */
  KG.posizioni = function (tipo, titolo) {
    var t = (tipo || '').toLowerCase();
    var cap = /cappuccio/i.test(titolo || '');   // nelle felpe col cappuccio il riquadro parte dal cappuccio: petto più in basso
    var vC = cap ? 0.42 : 0.35, vS = cap ? 0.33 : 0.27;
    if (t.indexOf('pantal') >= 0 || t.indexOf('bermuda') >= 0) return [
      { id: 'gamba-sx', nome: 'Gamba sinistra', u: 0.7, v: 0.2, s: 0.16, mh: 0.16, retro: false },
      { id: 'gamba-dx', nome: 'Gamba destra', u: 0.3, v: 0.2, s: 0.16, mh: 0.16, retro: false },
      { id: 'retro', nome: 'Retro', u: 0.5, v: 0.14, s: 0.26, mh: 0.12, retro: true }
    ];
    return [
      { id: 'petto-sx', nome: 'Petto sinistro', u: 0.63, v: vS, s: 0.15, mh: 0.15, retro: false },
      { id: 'centro', nome: 'Centro petto', u: 0.5, v: vC, s: 0.36, mh: 0.34, retro: false },
      { id: 'schiena', nome: 'Schiena', u: 0.5, v: vC, s: 0.42, mh: 0.46, retro: true }
    ];
  };
})();
